import React from 'react';
import { Icon } from '@iconify/react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { ReceiptInfo } from './ReceiptInfo';
import { BlockHeaderInfo, FormLabel } from 'components';
import { Anchor, ReceiptDrawerProps, styles } from './receipt-drawer-helpers';

export const ReceiptDrawer = (props: ReceiptDrawerProps): React.JSX.Element => {
    const {
        selectedReceipt: receiptInfo,
        setSelectedReceipt,
        chainType,
    } = props;

    const anchor: Anchor = 'right';

    const closeDrawer = (): void => {
        setSelectedReceipt();
    };
    return (
        <Drawer anchor={anchor} open={!!receiptInfo} sx={styles.drawer}>
            <IconButton
                color='secondary'
                sx={styles.drawerCloseButton}
                onClick={(): void => closeDrawer()}
            >
                <Icon icon='mdi:close' />
            </IconButton>
            <Box sx={styles.contentContainer}>
                <Box sx={styles.contentWrapper}>
                    <Typography variant='h2'>Receipt Info</Typography>
                    <ReceiptInfo
                        label='sdoId'
                        value={receiptInfo?.contractSdoId}
                    />
                    {chainType === 'consentcontracts' && (
                        <ReceiptInfo
                            label='loggedInId'
                            value={receiptInfo?.loggedInId}
                        />
                    )}
                    <ReceiptInfo
                        label='function'
                        value={receiptInfo?.receiptSmartContract?.function}
                    />
                    <ReceiptInfo
                        label='arguments'
                        value={JSON.stringify(
                            receiptInfo?.receiptSmartContract?.arguments
                        )}
                    />
                    <ReceiptInfo
                        label='response'
                        value={JSON.stringify(
                            receiptInfo?.receiptSmartContract?.response
                        )}
                    />
                    <ReceiptInfo
                        label='successful'
                        value={JSON.stringify(
                            receiptInfo?.receiptSmartContract?.successful
                        )}
                    />
                    <Box sx={styles.consoleWrapper}>
                        <FormLabel text='console' />
                        <Box sx={styles.consoleContainer}>
                            <code>
                                {receiptInfo?.receiptSmartContract?.console}
                            </code>
                        </Box>
                    </Box>
                    <ReceiptInfo
                        label='errorLog'
                        value={receiptInfo?.receiptSmartContract?.errorLog}
                    />
                </Box>
                <hr />
                <BlockHeaderInfo headerInfo={receiptInfo?.header} />
            </Box>
        </Drawer>
    );
};
